export const normalizeEventContentItem = (rawData) => {
  return {
    contentId: rawData?.content_id,
    category: rawData?.category,
    title: rawData?.title,
    image: rawData?.image,
    releaseDate: rawData?.releasedate,
    director: rawData?.director,
    actor: rawData?.actor,
    genres: rawData?.genres,
    synopsis: rawData?.synopsis,
  }
}

export const normalizeEventContentList = (rawData) => {
  if (!rawData) {
    return {}
  }
  const mainData = rawData?.[0] || {}
  return {
    list:
      mainData?.list?.map((eventContent) =>
        normalizeEventContentItem(eventContent),
      ) || [],
    pageCount: mainData?.pagecount,
    count: mainData?.count,
  }
}
